export const achievementData = {
    bio : "L'architecture est le jeu savant, correct et magnifique des volumes sous la lumière. – Le Corbusier",
    achievements: [
    {
        id: 1,
        title: 'Institut supérieur d’architecture et d’urbanisme Kinshasa /Gombe',
        details: '',
        date: '2015',
        field: 'Architecture',
        image: 'https://udemy-certificate.s3.amazonaws.com/image/UC-0cd075aa-f55b-4d9f-aec0-119020a4e792.jpg?v=1611846350000' // Remplacer par l\'image du diplôme
    },
    {
        id: 2,
        title: 'Certificat d’expert en passation des marchés publics',
        details: '',
        date: '2014',
        field: 'Architecture durable',
        image: 'https://udemy-certificate.s3.amazonaws.com/image/UC-0cd075aa-f55b-4d9f-aec0-119020a4e792.jpg?v=1611846350000' // Remplacer par l\'image du certificat LEED
    }
]

}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/